import React from 'react';
import CloseButton from './CloseButton';
import { ITagButton } from '../../../interfaces/buttons/buttons';

const TagButton = ({ content, closeAriaLabel, className, isDisabled = false, onButtonClick}: ITagButton) => {

    return (
        <div
            className={`tag-button ${className} ${isDisabled ? "disabled-tag-button" : ""}`}
        >
            <span>{content}</span>

            <CloseButton 
                ariaLabel={closeAriaLabel} 
                onButtonClick={onButtonClick}
            />
        </div>
    );
};

export default TagButton